import React from 'react';
import logoSeal from '../assets/logo-seal-white.png';
import photoFooter from '../assets/photo-footer.jpg';

export default function Footer() {
  return (
    <footer className="site-footer" style={{ ['--footer-photo' as any]: `url(${photoFooter})` }}>
      <div className="footer-inner">
        <img src={logoSeal} alt="" aria-hidden="true" className="footer-seal" />
        <p className="footer-location">Berthoud, Colorado</p>
        <p className="footer-tag">For town and neighbor</p>
        <p className="footer-email">
          <a href="mailto:info@gardenspotdevelopment.com">info@gardenspotdevelopment.com</a>
        </p>
        <p className="footer-bottom">
          &copy; {new Date().getFullYear()} Garden Spot Development. Growth That Belongs.
        </p>
      </div>
    </footer>
  );
}
